<template>
  <div class="app-content">
    <header>
      <div class="left">
        <i class="el-icon-s-unfold"
           :class="{'active': isSide}"
           @click="toogleSide"></i>
        圣墨</div>
      <div>
        <el-tabs>
          <el-tab-pane label="首页"
                       name="first">首页</el-tab-pane>
          <el-tab-pane label="github"
                       name="second">github</el-tab-pane>
        </el-tabs>
      </div>
    </header>
    <section>
      <div class="main-content">
        <div class="left"
             :class="{'active': isSide}">
          <side-bar></side-bar>
        </div>
        <div class="right s-markdown"
             @click="handleClickRight">
          <el-scrollbar style="height: 100%;">
            <router-link></router-link>
          </el-scrollbar>
        </div>
      </div>
    </section>
    <footer>底部</footer>

  </div>
</template>

<script>
import sideBar from '@/components/side-bar.vue';
import routerLink from './router-link.vue';
export default {
  name: 'app',
  components: {
    sideBar,
    routerLink
  },
  data() {
    return {
      isSide: false
    };
  },
  created() {},
  mounted() {
    this.isSide = document.body.offsetWidth < 768;
  },
  methods: {
    toogleSide() {
      this.isSide = !this.isSide;
    },
    handleClickRight() {
      if (document.body.offsetWidth < 768) {
        this.isSide = true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.app-content {
  position: relative;
  height: 100%;
  width: 100%;
  header {
    display: flex;
    height: 5rem;
    width: 100%;
    background: #2db7f5;
    box-sizing: border-box;
    color: #fff;
    padding: 0 2rem;
    line-height: 5rem;
    justify-content: space-between;
    .left {
      font-size: 20px;
      font-weight: bold;
      height: 100%;
      i {
        cursor: pointer;
        &.active {
          transform: scale(180deg);
        }
      }
    }
    /deep/ {
      .el-tabs__item {
        color: #fff;
      }
    }
  }
  section {
    height: calc(100% - 15rem);
    background-color: #f1f4f9;
    padding: 16px;
    .main-content {
      height: 100%;
      width: 100%;
      background-color: #fff;
      display: flex;
      /deep/ {
        .el-menu {
          border: none;
        }
      }
      .left {
        height: 100%;
        width: 20rem;
        border-right: 1px solid #2db7f5;
        transition: all 0.5s;
        &.active {
          width: 0;
          border-right: none;
        }
      }
      .right {
        flex: 1;
        padding: 10px;
      }
    }
  }

  footer {
    display: flex;
    height: 10rem;
    width: 100%;
    background: #2db7f5;
    box-sizing: border-box;
    color: #fff;
    padding: 0 2rem;
    line-height: 10rem;
    justify-content: space-between;
  }
}
</style>

<style>
.scale-enter-active {
  transition: 1s;
}

.scale-enter {
  transform: scale(0.6);
}
</style>
